import { Link } from 'react-router';
import sunfishLogo from '~assets/img/sunfish-logo.svg';
import { Button } from '@sunfish/ui';

export default function NotFound() {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-sidebar px-4">
			<div className="mb-8">
				<img src={sunfishLogo} alt="Sunfish Events" width={280} height={42} className="opacity-80" />
			</div>
			<div className="text-center">
				<h1 className="text-8xl font-bold text-muted-foreground/30">404</h1>
				<h2 className="mt-4 text-2xl font-semibold text-sidebar-foreground">Page Not Found</h2>
				<p className="mt-2 text-sidebar-foreground opacity-70">The page you're looking for doesn't exist or has been moved.</p>
				<div className="mt-8">
					<Button variant="brand" size="lg" asChild>
						<Link to="/events">Back to Events</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}
